function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import DropdownItems from '../../components/DropdownItems';
import RubriqSelectedCriteriaModal from './RubriqSelectedCriteriaModal';
var RubriqAbstractToolbar = function RubriqAbstractToolbar() {
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSelectedCriteriaModal = _useState2[0],
    setShowSelectedCriteriaModal = _useState2[1];
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    title = _useSelector.curie.abstractWriter.title;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "px-2 px-sm-0 pb-2 border-bottom border-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center gap-5"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/abstract-writer",
    className: "btn btn-primary rubriq-ghost-button d-flex align-items-center fw-semibold"
  }, /*#__PURE__*/React.createElement("span", {
    className: "p-1"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-chevron-left"
  })), /*#__PURE__*/React.createElement("span", {
    className: "ms-1 d-none d-sm-inline text-uppercase fs-6"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.abstracts"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "m-0 p-0 text-truncate",
    style: {
      flexShrink: 7
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "dropdown rubriq-dropdown"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('settings'),
    className: "btn btn-primary rubriq-ghost-button dropdown-toggle d-flex align-items-center",
    type: "button",
    id: "settings-toggle-button",
    "data-bs-toggle": "dropdown"
  }, /*#__PURE__*/React.createElement("span", {
    className: "p-1"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-gears"
  })), /*#__PURE__*/React.createElement("span", {
    className: "ms-1 d-none d-sm-inline"
  }, /*#__PURE__*/React.createElement(T, {
    source: "settings"
  }))), /*#__PURE__*/React.createElement("ul", {
    className: "dropdown-menu p-0",
    "aria-labelledby": "settings-toggle-button"
  }, /*#__PURE__*/React.createElement(DropdownItems, {
    items: [{
      label: 'rename',
      element: /*#__PURE__*/React.createElement("button", {
        "aria-label": t('rename'),
        type: "button",
        className: "dropdown-item btn btn-primary fw-normal"
      }, /*#__PURE__*/React.createElement(T, {
        source: "rename"
      }))
    }, {
      label: 'View Criteria',
      element: /*#__PURE__*/React.createElement("button", {
        "aria-label": t('view setup criteria'),
        type: "button",
        className: "dropdown-item btn btn-primary fw-normal",
        onClick: function onClick() {
          return setShowSelectedCriteriaModal(true);
        }
      }, /*#__PURE__*/React.createElement(T, {
        source: "view setup criteria"
      }))
    }]
  }))))), /*#__PURE__*/React.createElement(RubriqSelectedCriteriaModal, {
    open: showSelectedCriteriaModal,
    onClose: function onClose() {
      return setShowSelectedCriteriaModal(false);
    }
  }));
};
export default RubriqAbstractToolbar;